import React from "react";
import { Section, Overline, H1, Lead, H2, Card } from "@/components/ui-kit";
import InvestorForm from "@/components/forms/InvestorForm";

export default function Investors() {
  return (
    <>
      <Section className="pt-12 md:pt-20 pb-8 md:pb-10">
        <Overline>For Investors</Overline>
        <H1 className="mt-5 max-w-4xl">Invest alongside a Sacramento-focused value-add real estate operator.</H1>
        <Lead className="mt-7 max-w-3xl">
          Brightside Capital Ventures focuses on disciplined, asset-backed real estate opportunities with clear upside,
          conservative underwriting, and multiple exit paths.
        </Lead>
      </Section>

      <Section className="py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <H2 className="text-2xl">Investment Philosophy</H2>
            <ul className="mt-6 space-y-3 text-sm text-neutral-300">
              {[
                "Downside protection first","Conservative underwriting","Strong basis","Multiple exit strategies",
                "Clear, document-backed communication","Real estate-backed opportunities",
                "Focus on small multifamily, ADUs, infill, value-add, and cash-flowing rentals",
              ].map((t) => <li key={t} className="border-l border-[#C19B6C]/50 pl-4 py-1">{t}</li>)}
            </ul>
          </div>
          <div>
            <H2 className="text-2xl">Opportunity Types</H2>
            <ul className="mt-6 space-y-3 text-sm text-neutral-300">
              {[
                "Private lending","Joint ventures","Passive capital partnerships","Project-specific investments",
                "Future fund / syndication (placeholder)","Guarantor / credit-partner discussions where appropriate",
              ].map((t) => <li key={t} className="border-l border-[#C19B6C]/50 pl-4 py-1">{t}</li>)}
            </ul>
          </div>
        </div>
      </Section>

      <Section className="py-16">
        <Overline>What Investors Receive</Overline>
        <H2 className="mt-3 text-2xl">A documented, structured process.</H2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {["Deal summary","Use of funds","Risk factors","Exit strategy","Timeline","Return structure","Project updates","Documentation"].map((t) => (
            <Card key={t}><h3 className="font-display text-base">{t}</h3></Card>
          ))}
        </div>
      </Section>

      <Section className="py-12">
        <div className="card-frame p-6 md:p-8 border-[#C19B6C]/30">
          <div className="overline mb-3">Disclaimer</div>
          <p className="text-sm text-neutral-300 leading-relaxed">
            This website is for informational purposes only. Nothing on this site is an offer to sell securities or a
            solicitation to invest. Any investment opportunity will be offered only through appropriate documentation
            and in compliance with applicable laws.
          </p>
        </div>
      </Section>

      <Section className="pb-24 md:pb-32" id="investor-form-section" dataTestId="investor-form-section">
        <InvestorForm />
      </Section>

      <section className="border-t border-white/10 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-20 text-center">
          <H2 className="text-2xl max-w-3xl mx-auto">Want to be considered for future opportunities?</H2>
          <p className="text-neutral-400 mt-4 max-w-xl mx-auto">Conservative underwriting. Real estate-backed structures. Long-term relationships.</p>
          <a href="#investor-form-section" className="btn-gold inline-block mt-8 px-7 py-4 font-semibold">Join the investor list for future opportunities</a>
        </div>
      </section>
    </>
  );
}
